// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SHeM","newExpiryDate":"styles_newExpiryDate__2iz9o","footer":"styles_footer__13Fth"};